import { Graph, GraphNode } from './types.js';

export const isGraph = (node: any): node is Graph => {
  return node?.isGraph === true;
};

export const isGraphNode = (node: any): node is GraphNode => {
  return node?.isGraphNode === true;
};
